import { lazy } from "react";

export const ScorecardPage = lazy(() =>
  import("../pages/scorecard/scorecard-page.js").then((module) => ({
    default: module.ScorecardPage,
  })),
);
export const SeasonTeeOffPage = lazy(() =>
  import("../pages/fgl/season-setup.js").then((module) => ({
    default: module.SeasonTeeOffPage,
  })),
);
export const SettingsPage = lazy(() =>
  import("../pages/settings/settings-page.js").then((module) => ({
    default: module.SettingsPage,
  })),
);
export const ReviewsPage = lazy(() =>
  import("../pages/reviews/reviews-page.js").then((module) => ({
    default: module.ReviewsPage,
  })),
);
export const ReviewCard = lazy(() =>
  import("../pages/reviews/reviews-page.js").then((module) => ({
    default: module.ReviewCard,
  })),
);
export const StatsPage = lazy(() =>
  import("../pages/stats/stats-page.js").then((module) => ({
    default: module.StatsPage,
  })),
);
export const CoursesPage = lazy(() =>
  import("../pages/courses/courses-page.js").then((module) => ({
    default: module.CoursesPage,
  })),
);
export const FglPage = lazy(() =>
  import("../pages/fgl/fgl-page.js").then((module) => ({
    default: module.FglPage,
  })),
);
export const RivalryHubPage = lazy(() =>
  import("../pages/rivalry/rivalry-hub-page.js").then((module) => ({
    default: module.RivalryHubPage,
  })),
);
export const RivalsPage = lazy(() =>
  import("../pages/rivalry/rivals-page.js").then((module) => ({
    default: module.RivalsPage,
  })),
);
export const RoundsPage = lazy(() =>
  import("../pages/rounds/rounds-page.js").then((module) => ({
    default: module.RoundsPage,
  })),
);
export const TrophiesPage = lazy(() =>
  import("../pages/trophies/trophies-page.js").then((module) => ({
    default: module.TrophiesPage,
  })),
);
export const FeedPage = lazy(() =>
  import("../pages/feed/feed-page.js").then((module) => ({
    default: module.FeedPage,
  })),
);
